var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql, useQuery } from '@apollo/client';
import TICKET_FLAG_FRAGMENT from 'apollo/fragments/TICKET_FLAG_FRAGMENT';
// TICKET_FLAGS
var TICKET_FLAGS = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query TicketFlags($per_page: Int, $filters: TicketFlagsFilterInput) {\n    ticket_flags(per_page: $per_page, filters: $filters) {\n      nodes {\n        ...TICKET_FLAG_FRAGMENT\n      }\n    }\n  }\n  ", "\n"], ["\n  query TicketFlags($per_page: Int, $filters: TicketFlagsFilterInput) {\n    ticket_flags(per_page: $per_page, filters: $filters) {\n      nodes {\n        ...TICKET_FLAG_FRAGMENT\n      }\n    }\n  }\n  ", "\n"])), TICKET_FLAG_FRAGMENT);
export var useTicketFlagsQuery = function (options) {
    return useQuery(TICKET_FLAGS, options);
};
export default TICKET_FLAGS;
var templateObject_1;
